import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';

const COLORS = { high: '#1F8A4C', medium: '#E65100', low: '#9E9E9E' };

export default function ConfidenceDot({ confidence }) {
  const color = COLORS[confidence] || COLORS.low;
  return (
    <Tooltip title={`${confidence || 'low'} confidence`} placement="top">
      <Box
        component="span"
        sx={{
          display: 'inline-block',
          width: 8,
          height: 8,
          borderRadius: '50%',
          bgcolor: color,
          verticalAlign: 'middle',
          ml: 0.5,
        }}
      />
    </Tooltip>
  );
}
